export default "Here are some possible reasons:\n\n- You’re under 18 years of age\n- Systems maybe be offline\n- May not support your visa subclass\n";